import { Box, useBreakpointValue } from "@chakra-ui/react";
import { Listing } from "~/api/resources/Listings";
import { Region } from "~/api/resources/Regions";
import { BaseMap } from "./BaseMap";
import { getBoundsFromLonLats } from "./helpers";
import { Dispatch, SetStateAction, useState } from "react";
import { StopMarker } from "./Markers";
import { ListingInfoWindow } from "./InfoWindows";
import { MapSwitcher } from "./MapSwitcher";
import { useIsDesktop } from "~/lib/hooks";
import { useSliderContext } from "../Slider";
import { useMapContext } from "~/providers";
type Props = {
  region: Region;
  filteredListings: Listing[];
  setFilteredListings: Dispatch<SetStateAction<Listing[]>>;
};
export const RegionMap = ({ filteredListings }: Props) => {
  const { activeIndex, setActiveIndex } = useSliderContext();
  const isDesktop = useIsDesktop();
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const { mapSelected, setMapSelected } = useMapContext();
  const height = useBreakpointValue({
    base: "844px",
    md: "1194px",
    lg: "759px",
  });
  return (
    <Box>
      {showInfoWindow && !isDesktop && mapSelected && (
        <ListingInfoWindow
          listing={filteredListings[activeIndex]}
          onClose={() => setShowInfoWindow(false)}
        />
      )}
      <BaseMap
        onLoad={(map) => {
          const bounds = getBoundsFromLonLats(
            filteredListings.filter((listing) => !!listing.lonlat) as Array<{
              lonlat: string;
            }>,
          );
          map.fitBounds(bounds);
        }}
        mapContainerStyle={{
          height: height,
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        <MapSwitcher title="Stops list" pos="absolute" w="100%" />

        {filteredListings.map((listing, index) => {
          return (
            <StopMarker
              key={listing.id}
              record={listing}
              focused={index === activeIndex}
              onClick={() => {
                setActiveIndex(index);
                setShowInfoWindow(true);
              }}
            />
          );
        })}
      </BaseMap>
    </Box>
  );
};
